import {inject, Pipe, PipeTransform} from '@angular/core';
import {ImageCacheService} from '../services/images-cache/images-cache.service';

/**
 * Turns an authenticated image URL into a base64 data URL (fetched with the Bearer token and cached).
 * Use with the async pipe: [image]="user.avatarUrl | bearerImage | async".
 */
@Pipe({
  name: 'bearerImage',
})
export class BearerImagePipe implements PipeTransform {
  private readonly imageCacheService = inject(ImageCacheService);

  transform(imageUrl: string | null | undefined): Promise<string> | null {
    return imageUrl ? this.imageCacheService.getBase64Image(imageUrl) : null;
  }
}
